module.exports = __webpack_public_path__ + "static/media/13.358659de.jpg";